import React from 'react';
import { Button } from '@vtbhome/juicyfront';
import { Typography } from '@shared/ui/typography/typography';
import { Footer } from './modal-edit-photo-profile.styles';
import { ModalCancelProfileEditProps } from './types';
import { Modal } from '@shared/ui/modal/modal';

export const ModalCancelProfileEdit: React.FC<ModalCancelProfileEditProps> = ({ isShow, onClose, onAccept }) => {
    return (
        <Modal
            isShow={isShow}
            size='l'
            showLine={false}
            header={<Typography size='h5'>Отмена изменений</Typography>}
            footer={
                <Footer>
                    <Button buttonType='light' onClick={onClose}>
                        Отменить
                    </Button>
                    <Button buttonType='primary' onClick={onAccept}>
                        Подтвердить
                    </Button>
                </Footer>
            }
            onClose={onClose}>
            <Typography size='body1_long'>Вы действительно хотите отменить внесенные изменения?</Typography>
        </Modal>
    );
};
